import Vue from 'vue'
import submissionStore, { SubmissionPageName } from 'store/submission-store'

import withRender from './submission-mediator.html'
import './submission-mediator.scss'

const submissionPageComponents: { [key in SubmissionPageName]: Function } = {
  // tslint:disable-next-line
  'add-captions': () => import(/* webpackChunkName: 'add-captions' */ 'components/review-form/visual/add-captions'),
  // tslint:disable-next-line
  'add-video':  () => import(/* webpackChunkName: 'add-video' */ 'components/review-form/visual/add-video'),
  // tslint:disable-next-line
  'do-more':  () => import(/* webpackChunkName: 'do-more' */ 'components/do-more/do-more'),
  // tslint:disable-next-line
  registration:  () => import(/* webpackChunkName: 'registration' */ 'components/registration/registration'),
  // tslint:disable-next-line
  'review-form':  () => import(/* webpackChunkName: 'review-form' */ 'components/review-form/review-form'),
  // tslint:disable-next-line
  'seller-rating-form':  () => import(/* webpackChunkName: 'seller-ratings' */ 'components/seller-ratings/seller-rating-form'),
  // tslint:disable-next-line
  'share-media':  () => import(/* webpackChunkName: 'share-media' */ 'components/review-form/visual/share-media'),
  // tslint:disable-next-line
  'solo-question':  () => import(/* webpackChunkName: 'solo-question' */ 'components/question/solo-question'),
}

export default withRender(Vue.extend({
  data () {
    return {
      submissionPageComponents,
      submissionStore
    }
  },
  computed: {
    currentPage() {
      return this.submissionStore.currentPage ?
        this.submissionPageComponents[this.submissionStore.currentPage.page] : null
    },
    currentPageProps() {
      return this.submissionStore.currentPage ?
        this.submissionStore.currentPage.props : {}
    }
  },
  methods: {
    onShowError(message, endFlow = false, autoClose = true) {
      this.$emit('showError', message, endFlow, autoClose)
    },
    onShowPopoverMessage(message, endFlow = false) {
      this.$emit('showPopoverMessage', message, endFlow)
    },
    pageLoaded(preventClickOutside = false) {
      this.$emit('pageLoaded', preventClickOutside)
    },
    pageLoading() {
      this.$emit('pageLoading')
    }
  },
  beforeDestroy() {
    // before the review submission flow is destroyed, resetting the review submission store
    // so that if opened again, it does not have any lingering values from before.
    submissionStore.resetStore()
  },
  watch: {
    currentPage() {
      this.pageLoading()
    }
  }
}))
